/* RNG collection pages — read more, grid layout switch, load more with progress, recently viewed. */
(() => {
  if (window.__rngCollection) return;
  window.__rngCollection = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del(k) { try { localStorage.removeItem(k); } catch (e) {} },
  };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Read more on long collection descriptions ---------- */
  function initReadMore() {
    $$('[data-rng-clamp]').forEach((body) => {
      if (body.dataset.rngReady) return;
      body.dataset.rngReady = '1';
      const btn = body.parentElement.querySelector('[data-rng-more]');
      body.classList.add('is-clamped');
      if (body.scrollHeight - body.clientHeight < 4) { body.classList.remove('is-clamped'); return; }
      if (!btn) return;
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const open = body.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }

  /* ---------- Grid layout switch (remembered per shopper) ---------- */
  function applyView() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const d = store.get('rng-cols');
    const m = store.get('rng-mcols');
    if (d) grid.dataset.rngCols = d; else delete grid.dataset.rngCols;
    if (m) grid.dataset.rngMcols = m; else delete grid.dataset.rngMcols;
    const def = { d: grid.dataset.defaultCols, m: grid.dataset.defaultMcols };
    $$('[data-rng-view]').forEach((b) => {
      const isMobile = b.dataset.rngView === 'm';
      const cur = isMobile ? (m || def.m) : (d || def.d);
      b.setAttribute('aria-pressed', String(b.dataset.cols === cur));
    });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rng-view]');
    if (!b) return;
    store.set(b.dataset.rngView === 'm' ? 'rng-mcols' : 'rng-cols', b.dataset.cols);
    applyView();
  });

  /* ---------- Load more with progress (auto-loads the first pages on scroll) ---------- */
  function initLoadMore() {
    const prog = $('[data-rng-progress]');
    const grid = document.getElementById('product-grid');
    const pag = $('.pagination-wrapper');
    if (!prog || !grid || prog.dataset.rngReady) return;
    prog.dataset.rngReady = '1';
    if (pag) pag.dataset.rngInf = '1'; // tell the toolkit's infinite scroll to stand down
    const total = Number(prog.dataset.total || 0);
    const auto = Number(prog.dataset.auto || 0);
    let page = Number(prog.dataset.page || 1);
    let autoLoaded = 0;
    let busy = false;
    const text = prog.querySelector('[data-shown]');
    const bar = prog.querySelector('.rng-progress__bar span');
    const nextUrl = () => {
      const p = $('.pagination-wrapper');
      if (!p) return null;
      const u = $$('a[href]', p).map((a) => new URL(a.href, location.origin)).find((x) => Number(x.searchParams.get('page')) === page + 1);
      return u ? u.toString() : null;
    };
    if (!nextUrl()) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--secondary rng-progress__btn';
    btn.textContent = prog.dataset.label || 'Load more';
    prog.appendChild(btn);
    prog.classList.add('is-js');

    const update = () => {
      const shown = grid.children.length;
      if (text) text.textContent = shown;
      if (bar && total) bar.style.width = Math.min(100, (shown / total) * 100) + '%';
    };

    const load = async () => {
      const url = nextUrl();
      if (!url || busy) return;
      busy = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Loading…';
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = $$('#product-grid > *', doc);
        const frag = document.createDocumentFragment();
        items.forEach((n) => {
          [n].concat($$('.scroll-trigger', n)).forEach((x) => x.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in'));
          frag.appendChild(document.adoptNode(n));
        });
        grid.appendChild(frag);
        page += 1;
        const oldPag = $('.pagination-wrapper');
        const newPag = $('.pagination-wrapper', doc);
        if (oldPag) {
          if (newPag) { const imp = document.adoptNode(newPag); imp.dataset.rngInf = '1'; oldPag.replaceWith(imp); }
          else oldPag.remove();
        }
        update();
        document.dispatchEvent(new CustomEvent('rng:products-loaded'));
      } catch (e) {
        window.location.href = url;
        return;
      } finally {
        busy = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = prog.dataset.label || 'Load more';
      }
      if (!nextUrl()) { btn.remove(); io && io.disconnect(); }
    };

    btn.addEventListener('click', load);
    let io = null;
    if (auto > 0 && 'IntersectionObserver' in window) {
      io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting || busy) return;
        if (autoLoaded >= auto) { io.disconnect(); return; }
        autoLoaded += 1;
        load();
      }, { rootMargin: '600px 0px' });
      io.observe(prog);
    }
    update();
  }

  /* ---------- Recently viewed ---------- */
  const RV_KEY = 'rng-rv';
  const readRV = () => { try { return JSON.parse(store.get(RV_KEY) || '[]'); } catch (e) { return []; } };
  function money(cents, fmt) {
    const n = Number(cents || 0) / 100;
    const [i, d] = n.toFixed(2).split('.');
    const g = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return g(String(Math.round(n)), ',');
      if (k === 'amount_with_comma_separator') return g(i, '.') + ',' + d;
      if (k === 'amount_no_decimals_with_comma_separator') return g(String(Math.round(n)), '.');
      return g(i, ',') + '.' + d;
    });
  }
  function initRecentlyViewed() {
    const sec = $('[data-rng-rv]');
    if (!sec || sec.dataset.rngReady) return;
    sec.dataset.rngReady = '1';
    const current = sec.dataset.current;
    const max = Number(sec.dataset.max || 6);
    let list = readRV();
    if (current) {
      list = [current].concat(list.filter((h) => h !== current)).slice(0, 20);
      store.set(RV_KEY, JSON.stringify(list));
    }
    const show = list.filter((h) => h !== current).slice(0, max);
    if (!show.length) return;
    const fmt = sec.dataset.money;
    const render = async () => {
      const results = await Promise.all(show.map((h) => fetch(`${root}products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
      const items = results.filter(Boolean);
      const alive = new Set(items.map((p) => p.handle));
      store.set(RV_KEY, JSON.stringify(readRV().filter((h) => h === current || alive.has(h))));
      if (!items.length) return;
      const ul = sec.querySelector('[data-rng-rv-list]');
      ul.innerHTML = items.map((p) => {
        const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=360` : '';
        const onSale = p.compare_at_price && p.compare_at_price > p.price;
        const badge = !p.available
          ? '<span class="badge color-scheme-soldout">Sold out</span>'
          : onSale ? `<span class="badge color-scheme-sale">Sale -${Math.round((1 - p.price / p.compare_at_price) * 100)}%</span>` : '';
        return `<li><a class="rng-rv__card" href="${esc(p.url)}"><div class="rng-rv__media">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy" width="360" height="480">` : ''}${badge}</div><p class="rng-rv__title">${esc(p.title)}</p><p class="rng-rv__price">${onSale ? `<span class="is-sale">${money(p.price, fmt)}</span><s>${money(p.compare_at_price, fmt)}</s>` : `<span>${money(p.price, fmt)}</span>`}</p></a></li>`;
      }).join('');
      sec.hidden = false;
    };
    // Load only when the shopper scrolls near it (hidden elements never intersect, so watch a marker)
    if ('IntersectionObserver' in window) {
      const marker = document.createElement('div');
      sec.parentNode.insertBefore(marker, sec);
      const io = new IntersectionObserver((e) => {
        if (!e[0].isIntersecting) return;
        io.disconnect();
        marker.remove();
        render();
      }, { rootMargin: '600px 0px' });
      io.observe(marker);
    } else render();
    sec.querySelector('[data-rng-rv-clear]').addEventListener('click', () => {
      store.del(RV_KEY);
      if (current) store.set(RV_KEY, JSON.stringify([current]));
      sec.hidden = true;
    });
  }

  /* ---------- Boot + re-run after filters/sort re-render the grid ---------- */
  function run() {
    initReadMore();
    applyView();
    initLoadMore();
    initRecentlyViewed();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  let t;
  new MutationObserver(() => {
    // mark a freshly rendered pagination immediately so the toolkit's infinite scroll never grabs it
    const p = $('.pagination-wrapper');
    if (p && $('[data-rng-progress]')) p.dataset.rngInf = '1';
    clearTimeout(t);
    t = setTimeout(run, 60);
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
